import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import {Link} from "react-router";

import {DATE_FORMAT_ISO} from "config/constants";
import {getRouteLabel} from "utils";
import {Route} from "v2/api/Records";

const RouteLink = (props, context) => {
  const {location: {query}, params: {routeId}} = context;
  const {route} = props;

  const className = classnames({
    active: routeId && route.id === parseInt(routeId, 10),
  });
  const pathname = `/${route.date.format(DATE_FORMAT_ISO)}/${route.id}`;

  return (
    <Link className={className} to={{pathname, query}}>
      {getRouteLabel(route)}
    </Link>
  );
};

RouteLink.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    routeId: PropTypes.string,
  }),
};
RouteLink.propTypes = {
  route: PropTypes.instanceOf(Route),
};

export default RouteLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/RouteLink.js
 **/